@if (customer && project) {
    <div class="container project">
        @if (project.type !== 'drillings') {
            <div [class.hidden]="hideSidebar" class="sidebar">
                <div class="controls">
                    <button (click)="sidebarToggle()" color="primary" mat-icon-button>
                        <img src="../../../assets/images/icons/customer-projects/hide.svg" />
                    </button>
                    <div class="text d-md-none">Details en exporteren</div>

                    <button
                        mat-icon-button
                        class="d-md-none"
                        color="primary"
                        routerLink="/{{ Routenames.customers }}/{{ customerId }}"
                        [queryParams]="{ project: projectId }">
                        <mat-icon class="fas fa-map"></mat-icon>
                    </button>
                </div>
                <div class="content">
                    <div class="manager">
                        <div class="title">Projectleider</div>
                        <div class="name">{{ project?.manager_user?.name }}</div>
                        <div
                            [style.background-image]="project?.manager_user | profilePictureUrl | safeBgUrl"
                            class="photo"></div>
                        <div class="phone">{{ project.manager_user?.phone }}</div>
                        <div class="email">{{ project.manager_user?.email }}</div>
                    </div>
                    @if (counts && customerId) {
                        <div class="counts">
                            <h1>Status Delen</h1>
                            @for (count of counts; track count) {
                                <div class="count">
                                    <div [innerHTML]="count.count | marker: count.colorcode" class="marker"></div>
                                    <div>{{ count.name }}</div>
                                </div>
                            }
                        </div>
                    }
                    @if (customerId && (Functionalities.CustomerProjectsManage | hasFunctionality)) {
                        <div class="actions">
                            <button
                                (click)="openExportDialog('Pdf')"
                                color="primary"
                                mat-flat-button
                                [disabled]="generatingReport">
                                PDF
                                @if (generatingReport) {
                                    <i class="fas fa-circle-notch fa-spin"></i>
                                }
                            </button>
                            <button
                                (click)="openExportDialog('Excel')"
                                color="primary"
                                mat-flat-button
                                [disabled]="generatingExcel">
                                Excel
                                @if (generatingExcel) {
                                    <i class="fas fa-circle-notch fa-spin"></i>
                                }
                            </button>
                            <button (click)="zipExport()" color="primary" mat-flat-button [disabled]="zipExporting">
                                ZIP
                                @if (zipExporting) {
                                    <i class="fas fa-circle-notch fa-spin"></i>
                                }
                            </button>
                        </div>
                    }
                    <div class="d-flex justify-content-center flex-column mb-3">
                        @if (Functionalities.GeoManage | hasFunctionality) {
                            <button mat-button color="primary" (click)="projectDescription()">
                                Beschrijving aanpassen
                            </button>
                            <button
                                mat-button
                                color="secondary"
                                routerLink="/{{ Routenames.importExcel }}"
                                [queryParams]="{ customer: customer.id, project: project.id }">
                                Importeer excel
                            </button>
                            <button
                                mat-button
                                color="secondary"
                                routerLink="/{{ Routenames.importShapefile }}"
                                [queryParams]="{ customer: customer.id, project: project.id }">
                                Importeer shapefile
                            </button>
                        }
                    </div>
                    @if (project.consumers) {
                        <div class="d-flex justify-content-center mb-3">
                            <button
                                mat-button
                                routerLink="/{{ Routenames.customers }}/{{ project.customer_id }}/{{
                                    Routenames.projects
                                }}/{{ project.id }}/{{ Routenames.consumers }}">
                                Aanmeldingen bewoners
                            </button>
                        </div>
                    }
                </div>
            </div>
        }
        <div class="content">
            <div class="header mt-2">
                <div class="row">
                    <div class="col-auto pe-md-5">
                        <h2>
                            <span>{{ customer.name }}</span> {{ project.name }}
                            @if (Functionalities.CustomerProjectsManage | hasFunctionality) {
                                <button (click)="editProject()" color="primary" mat-icon-button>
                                    <mat-icon class="fa fa-edit"></mat-icon>
                                </button>
                            }
                        </h2>
                        @if (pendingAccessCount) {
                            <div (click)="editProject()" class="pending-access curpoint">
                                <i class="fas fa-user-clock me-1"></i>
                                {{ pendingAccessCount }}
                                {{
                                    pendingAccessCount === 1
                                        ? 'openstaand toegangsverzoek'
                                        : 'openstaande toegangsverzoeken'
                                }}
                            </div>
                        }
                        <div class="d-flex align-items-baseline justify-content-between">
                            @if (project.budget) {
                                <h3>Budget: &euro; {{ project.budget | number: '0.0-2' }}</h3>
                            }
                            @if (project?.customer_manager_user?.name) {
                                @if (Functionalities.CustomerProjectsManage | hasFunctionality) {
                                    <small
                                        [routerLink]="[
                                            '/',
                                            Routenames.users,
                                            project?.customer_manager_user?.id,
                                            {
                                                backTo:
                                                    '/' +
                                                    Routenames.customers +
                                                    '/' +
                                                    customerId +
                                                    '/' +
                                                    Routenames.projects +
                                                    '/' +
                                                    project.id,
                                            },
                                        ]"
                                        class="curpoint">
                                        Projectleider gemeente: {{ project.customer_manager_user.name }}
                                    </small>
                                } @else {
                                    <small>Projectleider gemeente: {{ project.customer_manager_user.name }}</small>
                                }
                            }
                        </div>
                    </div>
                    @if (project.type !== 'drillings') {
                        <div class="col-auto d-none d-md-flex justify-content-center align-items-center">
                            <a
                                routerLink="/{{ Routenames.customers }}/{{ customerId }}"
                                [queryParams]="{ project: projectId }"
                                class="button mx-0 ms-5">
                                Delen op kaart bekijken
                            </a>
                        </div>
                    }
                    @if (project.type === 'drillings' && customerId) {
                        <div class="col-lg col-24 justify-content-start align-items-start d-flex flex-wrap">
                            @if (
                                [Functionalities.GeoManage, Functionalities.CustomerProjectsManage] | hasFunctionality
                            ) {
                                <a (click)="openExportDialog('Pdf')" class="button mx-0 ms-2 mt-2">
                                    {{ generatingReport ? 'PDF wordt gemaakt...' : 'PDF' }}
                                </a>
                                <a (click)="openExportDialog('Excel')" class="button mx-0 ms-2 mt-2 mt-2">
                                    {{ generatingExcel ? 'Excel wordt gemaakt...' : 'Excel' }}
                                </a>
                            }
                            <a
                                routerLink="/{{ Routenames.customers }}/{{ customerId }}"
                                [queryParams]="{ project: projectId }"
                                class="button mx-0 ms-2 mt-2">
                                Delen op kaart bekijken
                            </a>
                        </div>
                    }
                </div>
                <app-customer-logo class="d-none d-md-block" [customer]="customer"></app-customer-logo>
            </div>
            <div class="detail">
                @if (project.type !== 'drillings') {
                    <div class="row">
                        <div class="col-md-12 col-lg-10 mb-3 mb-md-0">
                            <div class="d-flex align-items-center justify-content-between">
                                <h1 class="mb-0">Projectfasen</h1>
                                <mat-checkbox color="primary" class="me-2" [formControl]="showDonePhasesControl">
                                    Toon gereed
                                </mat-checkbox>
                            </div>
                            <app-customer-project-phase-list
                                (phaseSelected)="selectedPhase = $event; selectedActivity = null"
                                [currentProjectPhase]="project.customer_project_phase"
                                [projectPhases]="project.customer_project_phases"
                                [project]="project"
                                [showDonePhases]="showDonePhases()"
                                [selectedPhase]="selectedPhase">
                            </app-customer-project-phase-list>
                        </div>
                        <div class="col-md-12 col-lg-14" cdkDropListGroup>
                            <div class="d-flex align-items-center justify-content-between">
                                <h1 class="mb-0">Activiteiten</h1>
                                <mat-checkbox color="primary" [formControl]="showDoneActivitiesControl">
                                    Toon gereed
                                </mat-checkbox>
                            </div>
                            @if (selectedPhase) {
                                <app-customer-project-phase-activities
                                    (activitySelected)="selectedActivity = $event"
                                    (replyDropped)="customerProjectPhaseReplies.moveToActivity($event)"
                                    [projectReplies]="selectedPhase.customer_project_phase_replies"
                                    [selectedActivity]="selectedActivity"
                                    [activities]="selectedPhase.customer_project_phase_activities"
                                    [showDoneActivities]="showDoneActivities()"
                                    [phase]="selectedPhase">
                                </app-customer-project-phase-activities>
                            } @else {
                                <small> Selecteer een projectfase </small>
                            }

                            <h1 class="mt-3">
                                Documenten {{ selectedActivity ? 'van ' + selectedActivity.name : '' }}
                            </h1>

                            @if (selectedPhase) {
                                <app-customer-project-phase-replies
                                    #customerProjectPhaseReplies
                                    [selectedActivity]="selectedActivity"
                                    [phase]="selectedPhase"
                                    [highlightId]="highlightActivityReplyId"
                                    [replies]="selectedPhase.customer_project_phase_replies">
                                </app-customer-project-phase-replies>
                            } @else {
                                <small> Selecteer een projectfase </small>
                            }
                        </div>
                    </div>
                }
                @if (project.type === 'drillings' && form) {
                    <div class="row">
                        <div class="col-md-16">
                            <h1>Algemeen</h1>
                            <div>
                                <form [formGroup]="form">
                                    <mat-form-field class="w-100">
                                        <mat-label>Boormeester</mat-label>
                                        <input [formControl]="fc.driller" matInput type="text" />
                                        <mat-error [control]="fc.driller"></mat-error>
                                    </mat-form-field>
                                    <mat-form-field class="w-100">
                                        <mat-label>Soort boring</mat-label>
                                        <mat-select [formControl]="fc.drillingType">
                                            @for (option of dropdownOptions.drillingType; track option) {
                                                <mat-option [value]="option">
                                                    {{ option }}
                                                </mat-option>
                                            }
                                        </mat-select>
                                        <mat-error [control]="fc.drillingType"></mat-error>
                                    </mat-form-field>
                                    <mat-form-field class="w-100">
                                        <mat-label>Soort fundering:</mat-label>
                                        <mat-select [formControl]="fc.foundationType">
                                            @for (option of dropdownOptions.foundationType; track option) {
                                                <mat-option [value]="option">
                                                    {{ option }}
                                                </mat-option>
                                            }
                                        </mat-select>
                                        <mat-error [control]="fc.foundationType"></mat-error>
                                    </mat-form-field>
                                    <mat-form-field class="w-100">
                                        <mat-label>Werknummer</mat-label>
                                        <input [formControl]="fc.worknumber" matInput type="text" />
                                        <mat-error [control]="fc.worknumber"></mat-error>
                                    </mat-form-field>
                                    <mat-form-field class="w-100">
                                        <mat-label>Straatnaam</mat-label>
                                        <input [formControl]="fc.street" matInput type="text" />
                                        <mat-error [control]="fc.street"></mat-error>
                                    </mat-form-field>
                                    <mat-form-field class="w-100">
                                        <mat-label>Klantnaam</mat-label>
                                        <input [formControl]="fc.customer" matInput type="text" />
                                        <mat-error [control]="fc.customer"></mat-error>
                                    </mat-form-field>
                                    <mat-form-field (click)="picker.open()" class="w-100">
                                        <mat-label>Datum uitvoering</mat-label>
                                        <input [formControl]="fc.execution_date" [matDatepicker]="picker" matInput />
                                        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                        <mat-error [control]="fc.execution_date"></mat-error>
                                    </mat-form-field>
                                    @if (
                                        !(
                                            [Functionalities.GeoManage, Functionalities.CustomerProjectsManage]
                                            | hasFunctionality
                                        )
                                    ) {
                                        <div [innerHTML]="fc.description.value"></div>
                                    } @else {
                                        <simple-tiny
                                            [content]="fc.description"
                                            elementId="description"
                                            ngDefaultControl
                                            propertyName="value"></simple-tiny>
                                    }
                                </form>
                                @if (
                                    [Functionalities.GeoManage, Functionalities.CustomerProjectsManage]
                                        | hasFunctionality
                                ) {
                                    <div class="mt-2 mb-2">
                                        <button (click)="save()" class="button m-0">Opslaan</button>
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="col-md-8 mb-5 mt-3 mt-md-0">
                            <h1>Documenten</h1>
                            <div class="document-list">
                                <div
                                    (cdkDropListDropped)="drop($event, project.extra.reports)"
                                    cdkDropList
                                    [cdkDropListDisabled]="
                                        !(
                                            [Functionalities.GeoManage, Functionalities.CustomerProjectsManage]
                                            | hasFunctionality
                                        )
                                    ">
                                    @for (file of project.extra.reports; track file) {
                                        <div cdkDrag class="document">
                                            <div class="prefix">
                                                <div class="icon"></div>
                                                @if (
                                                    [Functionalities.GeoManage, Functionalities.CustomerProjectsManage]
                                                        | hasFunctionality
                                                ) {
                                                    <button (click)="deleteReport(file)" color="warn" mat-icon-button>
                                                        <mat-icon class="fas fa-trash"></mat-icon>
                                                    </button>
                                                }
                                            </div>
                                            <div>
                                                {{ file }}
                                            </div>
                                        </div>
                                    }
                                </div>
                                @if (
                                    [Functionalities.GeoManage, Functionalities.CustomerProjectsManage]
                                        | hasFunctionality
                                ) {
                                    <app-document-upload
                                        (uploaded)="fileUploaded($event)"
                                        [buttonIcon]="true"
                                        [customer]="customer"
                                        currentPath="{{ project.id }}"
                                        storage="drillings"></app-document-upload>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
}
